import styled from 'styled-components';
import {injectAdaptive} from 'ui/theme';

export const Wrapper = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 20;
  ${(p) => injectAdaptive('height', p.theme.keyBoardHeightValues)}

  .center {
    height: 100%;
    padding: 0;
  }

  &.is-enter-active,
  &.is-exit-active {
    ${(p) => p.theme.defaultAnimationStyle}
  }

  &.is-enter,
  &.is-exit-active {
    transform: translateY(50vh);
    opacity: 0;
  }

  &.is-enter-active {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const Grid = styled.div`
  display: flex;
  height: 100%;
  background-color: ${(p) => p.theme.keyBackground};
`;

export const Left = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 75%;
  height: 100%;
`;

export const Right = styled.div`
  width: 25%;
  height: 100%;
`;

type Percentage = string;

interface CellProps {
  width?: Percentage;
  height?: Percentage;
}

export const Cell = styled.div<CellProps>`
  width: ${(p) => p.width || '33.33%'};
  height: ${(p) => p.height || '25%'};
`;
